var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-banner-fixed"},[_c('div',{staticClass:"base-banner-fixed__content"},[_vm._t("content")],2),_c('BaseRoundButton',{attrs:{"icon":"x","isLight":"","isTransparent":""},nativeOn:{"click":function($event){return _vm.closeBanner.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }